import { layoutTypeState } from '@atom/setting/homepageSet';
import { LAYOUT_TYPE_VALUE } from '@typings/setting/layoutType';
import React from 'react';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import styled, { css } from 'styled-components';
import { versionUpdateData } from '../versionUpdateList';
import { versionUpdateModalState } from '@atom/setting/versionUpdate';
import { APP_VERSION } from '@constants/appVersion';

const footerLayoutTypeMap = {
  topType: css``,
  leftType: css`
    /* max-width: 1280px;
    padding: 0 12px 0 calc(220px + 12px); */
  `,
  hamburgerType: css``,
  tabsType: css``,
};

const FooterContainer = styled.footer.withConfig({
  shouldForwardProp: (prop: string) => prop !== 'layoutType',
}) <{ layoutType?: LAYOUT_TYPE_VALUE }>`
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px ${({ layoutType }) => layoutType && footerLayoutTypeMap[layoutType]};
  line-height: 1.5;
  color: var(--subTextColor);
`;

const FooterInfo = styled.p`
  padding: 4px 0;
  font-size: 11px;

  a {
    text-decoration: underline;
  }

  @media (max-width: 480px) {
    text-align: center;
  }
`;

function ServiceFooter() {
  const layoutType = useRecoilValue(layoutTypeState);
  const setShowVersionModal = useSetRecoilState(versionUpdateModalState);

  // 현재 버전 데이터 확인
  const currentVersionData = versionUpdateData.find(
    (data) => data.version === APP_VERSION,
  );

  // 버전 버튼 클릭 (모달 열기)
  const handleVersionButtonClick = () => {
    setShowVersionModal((prev) => !prev);
  };

  return (
    <>
      <FooterContainer layoutType={layoutType}>
        <FooterInfo>
          <strong>
            ©
            <a
              href="https://twitter.com/moogongan"
              target="_blank"
              rel="noopener noreferrer"
            >
              moogongan
            </a>
            . All Rights Reserved v.{APP_VERSION}
            &nbsp;&nbsp; | &nbsp;&nbsp;
            <a
              href="https://moogongan-guide.notion.site/"
              target="_blank"
              rel="noopener noreferrer"
            >
              이용 가이드
            </a>
            &nbsp;&nbsp; | &nbsp;&nbsp;
            <a
              href="https://moogongan-update.notion.site/"
              target="_blank"
              rel="noopener noreferrer"
            >
              업데이트 내역
            </a>
          </strong>

          {currentVersionData && (
            <>
              &nbsp;&nbsp; | &nbsp;&nbsp;
              <a
                onClick={(e) => {
                  e.preventDefault();
                  handleVersionButtonClick();
                }}
                style={{ cursor: 'pointer' }}
              >
                현재 버전 안내
              </a>
            </>
          )}
        </FooterInfo>
      </FooterContainer>
    </>
  );
}

export default React.memo(ServiceFooter);
